import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
  {
    id: 'digital-delivery',
    heading: '1. Digital Service Delivery',
    body: ['Digital services are considered delivered and fully earned by the Company when:'],
    list: [
      'The system is activated; OR',
      'Setup or onboarding work has begun; OR',
      'Access / login is granted; OR',
      'Any configuration work has been initiated.',
    ],
    subsections: [
      {
        body: [
          "Delivery does not depend on the user's availability, usage, or readiness. Once delivered, all payments remain strictly non-refundable.",
        ],
      },
    ],
  },
  {
    id: 'subscription-fees',
    heading: '2. Subscription Fees',
    body: [
      'Except when required by law, all paid subscription fees are non-refundable. This includes:',
    ],
    list: [
      { label: 'Setup and Activation Fees', text: 'All initial fees required to launch your service are final.' },
      { label: 'Partial Periods', text: 'There will be no refunds or credits for partial periods of service.' },
      { label: 'Unused Service', text: 'No refunds will be granted for service periods that go unused by the user.' },
      { label: 'Price Adjustments', text: 'There are no refunds for price differences resulting from upgrading or downgrading your plan.' },
    ],
  },
  {
    id: 'auto-renewals',
    heading: '3. Automatic Renewals',
    body: [
      'Subscriptions are automatically renewed through the payment method chosen during purchase.',
    ],
    list: [
      { label: 'Cancellation Responsibility', text: "It is the User's sole responsibility to cancel the subscription through the appropriate self-service settings within Aina Suite." },
      { label: 'Renewal Finality', text: 'The Company does not process cancellations on behalf of users, and no refunds will be issued for charges processed due to a failure to cancel before the renewal date.' },
    ],
  },
  {
    id: 'no-chargebacks',
    heading: '4. No Chargebacks',
    body: [
      'By using the Service, you explicitly agree that all payments are final and non-refundable.',
    ],
    list: [
      { label: 'Dispute Ban', text: 'You agree not to initiate any chargeback, reversal, or payment dispute through your bank or credit card provider for any reason.' },
      { label: 'Consequences', text: 'Filing a chargeback constitutes a breach of contract. Aina Suite reserves the right to suspend or permanently ban your access and recover all losses, fees, and administrative costs directly from you.' },
    ],
  },
  {
    id: 'exceptions',
    heading: '5. Exceptions',
    body: [
      'Certain refund requests, such as those arising from clear billing errors (e.g., duplicate transactions), may be considered on a case-by-case basis and granted at the sole discretion of the Company.',
    ],
  },
];

const contact = {
  heading: 'Contact Information',
  body: (
    <>
      For billing inquiries or to report a technical discrepancy, please contact us at <a href="mailto:hello@ainasuite.com">hello@ainasuite.com</a>.
    </>
  ),
};

export default function Refund() {
  return (
    <LegalPage
      title="Refund Policy"
      updated="May 12, 2026"
      intro={
        <>
          At Aina Suite (<a href="https://ainasuite.com/">https://ainasuite.com/</a>), we strive to provide the highest quality AI-driven automation services. Due to the digital and on-demand nature of our platform, this Refund Policy outlines the conditions regarding payments and service delivery.
        </>
      }
      sections={sections}
      contact={contact}
    />
  );
}
